/* @ngInject */
function tasksService (ConnectorWebService, CONSTANTS, Utils, BoardColumnsService, SegmentService) {
  const service = {
    batchDownloadAttachments,
    createRequestFromBriefing,
    getPriorities,
    getTasks,
    getTaskById,
    updateTaskFields,
    updateTaskStatus,
    updateTaskAuthor,
    updateTaskOcculted,
    rateTask,
    getTaskActivity,
    updateTaskAssignee,
    attachAssetToTask,
    removeAttachment,
    removeAttachmentsBatch,
    addTaskComment,
    editTaskComment,
    getTaskComments,
    deleteTaskComment,
    getAssetComments,
    addAssetComment,
    editAssetComment,
    getBriefing,
    updateBriefing,
    updateTaskAttachmentVisibility,
    setTaskAttachmentAsVisualized,
    setTaskAttachmentAsVisualizedBatch,
    getRequests,
    createTask,
    getAttachments,
    getAttachmentsCountPerTab,
    getWhetherUserDownloadedAttachment,
    getWhetherTaskWasRated,
    getBriefingVersions,
    getAssetPins,
    deleteAssetComment,
    approveTask,
    getRequestsCount,
    getArchivedTasks,
    changeIsPrivate,
    changeIsPrivateBatch,
    getSubtasks,
    createSubtask,
    editSubtaskTitle,
    archiveSubtask,
    unarchiveSubtask,
    updateSubtaskAssignee,
    updateSubtaskStatus,
    reorderSubtask,
    getMyTasks,
    getCalendarTasks,
    getRequestsByStatus,
    getRequestsCountByStatus,
    addRelatedTask,
    deleteRelatedTask,
    getRecentTasks,
    getRelatedTasks,
    updateTaskPosition,
    changeTaskStatus,
    changeSubtaskStatus,
    downloadTaskPdf,
    getMentionableUsersByTask,
    bindTaskToCampaign,
    unbindTaskFromCampaign,
    getTaskActiveInternalApproval,
    duplicateTask,
    getTaskActivityBatch,
    getTaskDocuments,
    createTaskDocument,
    deleteTaskDocument,
    attachDocumentsToTask,
    moveToNextColumn
  }
  return service

  function createRequestFromBriefing (data) {
    return ConnectorWebService.post(CONSTANTS.URL_TASKS_REQUESTS, data)
  }

  function getPriorities () {
    return ['LOW', 'MEDIUM', 'HIGH', 'URGENT']
  }

  function getTaskById (id, shouldMarkCommentsAsRead = true) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID, [id])
    url = Utils.fnAddQueryToUrl(url, { shouldMarkCommentsAsRead })

    return ConnectorWebService.get(url)
  }

  function updateTaskFields (id, params) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID, [id])
    return ConnectorWebService.put(url, params)
  }

  function updateTaskStatus (id, params) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_STATUS, [id])
    return ConnectorWebService.put(url, params)
  }

  function updateTaskAuthor (id, params) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_AUTHOR, [id])
    return ConnectorWebService.put(url, params)
  }

  function updateTaskOcculted (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_OCCULTED, [id])
    return ConnectorWebService.put(url)
  }

  function rateTask (id, params) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_RATE, [id])
    return ConnectorWebService.post(url, params)
  }

  function getTaskActivity (id, top, skip) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_ACTIVITY, [id])

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    return ConnectorWebService.get(url)
  }

  function updateTaskAssignee (id, assignees) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_ASSIGNEES, [id])
    return ConnectorWebService.put(url, { assignees })
  }

  function addTaskComment (sId, sValue, isPrivate, userIds) {
    isPrivate = isPrivate || false
    var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_COMMENT, [sId])
    return ConnectorWebService.post(sUrl, { value: sValue, isPrivate: isPrivate, userIds: userIds })
  }

  function editTaskComment (sId, sIdComment, sValue, isPrivate, userIds) {
    isPrivate = isPrivate || false
    var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_COMMENT_EDIT, [sId, sIdComment])
    return ConnectorWebService.put(sUrl, { value: sValue, isPrivate: isPrivate, userIds: userIds })
  }

  function getTaskComments (id, top, skip, filter) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_COMMENTS, [id])

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    if (filter) {
      url = Utils.fnAddQueryToUrl(url, { filter })
    }

    return ConnectorWebService.get(url)
  }

  function deleteTaskComment (id, commentId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_COMMENT_EDIT, [id, commentId])

    return ConnectorWebService.fnDelete(url)
  }

  function getAssetComments (assetId, top, skip, taskId) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_ASSET_COMMENTS, [assetId])

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    if (taskId) {
      url = Utils.fnAddQueryToUrl(url, { taskId })
    }

    return ConnectorWebService.get(url)
  }

  function addAssetComment (sAssetId, sTaskId, sValue, isPrivate, oPin, aUserIds) {
    var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_ASSET_COMMENT, [sAssetId])
    var payload = {
      comment: {
        value: sValue,
        private: isPrivate
      },
      origin: {
        type: 'WORKFLOW',

        originId: sTaskId
      }
    }
    if (oPin) {
      payload.pin = oPin
    }
    if (aUserIds) {
      payload.userIds = aUserIds
    }
    return ConnectorWebService.post(sUrl, payload)
  }

  function editAssetComment (sId, sValue, isPrivate, oPin, aUserIds) {
    var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_ASSET_COMMENT_EDIT, [sId])
    var payload = {
      comment: {
        value: sValue,
        private: isPrivate
      }
    }
    if (oPin) {
      payload.pin = oPin
    }
    if (aUserIds) {
      payload.userIds = aUserIds
    }
    return ConnectorWebService.put(sUrl, payload)
  }

  function deleteAssetComment (sId) {
    var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_ASSET_COMMENT_EDIT, [sId])

    return ConnectorWebService.fnDelete(sUrl)
  }

  function getBriefing (id, version, archivedFields) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_BRIEFING, [id])

    if (version) {
      url = Utils.fnAddQueryToUrl(url, { version: version })
    }

    if (typeof archivedFields === 'boolean') {
      url = Utils.fnAddQueryToUrl(url, { archivedFields })
    }

    return ConnectorWebService.get(url)
  }

  function getBriefingVersions (taskId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_BRIEFING_VERSIONS, [taskId])

    return ConnectorWebService.get(url)
  }

  function getAssetPins (assetId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ASSET_PINS, [assetId])

    return ConnectorWebService.get(url)
  }

  function updateBriefing (id, data) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_BRIEFING, [id])
    return ConnectorWebService.put(url, data)
  }

  function getTaskActivityBatch (params) {
    let url = CONSTANTS.URL_TASKS_ACTIVITY_BATCH

    if (params) {
      url = Utils.fnAddQueryToUrl(url, params)
    }

    return ConnectorWebService.get(url)
  }

  /**
   * @param {*} taskId
   * @param {*} oData
   * @param {*} oData.oldColumnId
   * @param {*} oData.newColumnId
   * @param {*} oData.oldPosition
   * @param {*} oData.newPosition
   */

  function updateTaskAttachmentVisibility (taskAttachmentId, isPrivate) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ATTACHMENTS_ID, [taskAttachmentId])
    return ConnectorWebService.put(url, { isPrivate })
  }

  function setTaskAttachmentAsVisualized (taskId, taskAttachmentId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ATTACHMENTS_VISUALIZED_ID, [taskId, taskAttachmentId])
    return ConnectorWebService.put(url)
  }

  function setTaskAttachmentAsVisualizedBatch (taskId, assetsIds) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ATTACHMENTS_VISUALIZED_BATCH, [taskId])
    return ConnectorWebService.put(url, { assetsIds })
  }

  function getTaskActiveInternalApproval (taskId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASK_V2_ID_ACTIVE_APPROVAL, [taskId])
    return ConnectorWebService.get(url)
  }

  function getRequests (params) {
    let url = CONSTANTS.URL_TASKS_REQUESTS
    if (params.search) {
      url = Utils.fnAddQueryToUrl(url, { search: params.search })
    }

    if (params.filters) {
      Object.keys(params.filters).forEach(key => {
        if (key === 'priority') {
          url = Utils.addQueryStringFromArray(url, key, params.filters[key])
        } else {
          url = Utils.fnAddQueryToUrl(url, { [key]: params.filters[key] })
        }
      })
    }

    if (params.status) {
      url = Utils.fnAddQueryToUrl(url, { status: params.status })
    }

    if (params.$sort || params.$order) {
      url = Utils.fnAddQueryToUrl(url, { $sort: params.$sort, $order: params.$order })
    }

    if (params.$top || params.$skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, params.$top, params.$skip)
    }

    return ConnectorWebService.get(url)
  }

  function getTasks (params) {
    let url = CONSTANTS.URL_TASKS

    if (params) {
      url = Utils.fnAddQueryToUrl(url, params)
    }

    return ConnectorWebService.get(url)
  }

  function getMyTasks (top, skip, order) {
    let url = CONSTANTS.URL_TASKS_ME

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    if (order) {
      const params = {
        $sort: order.sort,
        $order: order.order
      }

      url = Utils.fnAddQueryToUrl(url, params)
    }

    return ConnectorWebService.get(url)
  }

  function createTask (params) {
    return ConnectorWebService.post(CONSTANTS.URL_TASKS, params)
  }

  /* Filter options:
   * 'sent': Show only attachments the user has sent
   * 'received': Show only attachments that are not from the requestor
   * 'public': Show only attachments that are not private to the marketing team
   * 'private': Show only attachments privates to the marketing team
   * 'requestorOnly': Show only attachments that are from the requestor
   */
  function getAttachments (id, isUserOrGuest, filter, assetsIds) {
    const baseUrl = isUserOrGuest ? CONSTANTS.URL_TASKS_ID_ATTACHMENTS_USER : CONSTANTS.URL_TASKS_ID_ATTACHMENTS
    let url = Utils.fnReplaceStringParams(baseUrl, [id])

    if (filter) {
      url = Utils.fnAddQueryToUrl(url, { filter })
    }

    if (assetsIds?.length) {
      url = Utils.fnAddQueryToUrl(url, { assetsIds })
    }

    return ConnectorWebService.get(url)
  }

  function getAttachmentsCountPerTab (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_ATTACHMENTS_COUNT, [id])
    return ConnectorWebService.get(url)
  }

  function downloadTaskPdf (id, briefingVersion) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_PDF, [id])
    url = Utils.fnAddQueryToUrl(url, { briefingVersion })

    return Utils.downloadFile(url)
  }

  function getWhetherUserDownloadedAttachment (assetId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ATTACHMENTS_ID_DOWNLOAD_LOGS, [assetId])
    return ConnectorWebService.get(url)
  }

  function getWhetherTaskWasRated (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_RATE, [id])
    return ConnectorWebService.get(url)
  }

  function getRequestsCount () {
    return ConnectorWebService.get(CONSTANTS.URL_TASKS_REQUESTS_COUNT)
  }

  function changeIsPrivate (assetId, isPrivate) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ATTACHMENT_PRIVATE, [assetId])

    return ConnectorWebService.put(url, { isPrivate })
  }

  function changeIsPrivateBatch (taskId, assetsIds, isPrivate) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_ATTACHMENT_PRIVATE_BATCH, [taskId])
    return ConnectorWebService.put(url, { assetsIds, isPrivate })
  }

  function getArchivedTasks (top, skip, sort, search) {
    let url = CONSTANTS.URL_TASKS_ARCHIVED

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }
    if (search) {
      url = Utils.fnAddQueryToUrl(url, { search: search })
    }
    if (sort) {
      url = Utils.fnAddQueryToUrl(url, { $sort: sort.name, $order: sort.order })
    }

    return ConnectorWebService.get(url)
  }

  /**
   * @param {object} params.isArchived
   */
  function getSubtasks (taskId, params) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_SUBTASK, [taskId])

    if (params) {
      url = Utils.fnAddQueryToUrl(url, params)
    }

    return ConnectorWebService.get(url)
  }

  /**
   * @param {object} params.title
   * @param {Array} params.boardId
   * @param {object} params.taskId
   * @param {object} params.status - ['PROGRESS' || 'DONE' || 'INBOX'] (DEFAULT INBOX)
   * @param {object} params.priority
   */
  function createSubtask (params) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_SUBTASK, [params.taskId])

    return ConnectorWebService.post(url, params)
  }

  function editSubtaskTitle (subtaskId, title) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID, [subtaskId])

    return ConnectorWebService.put(url, { title })
  }

  function archiveSubtask (subtaskId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID, [subtaskId])

    return ConnectorWebService.put(url, { isArchived: true })
  }

  function unarchiveSubtask (subtaskId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID, [subtaskId])

    return ConnectorWebService.put(url, { isArchived: false })
  }

  function updateSubtaskAssignee (id, assignees) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_ASSIGNEES, [id])
    return ConnectorWebService.put(url, { assignees })
  }

  function updateSubtaskStatus (id, status, boardId, ignoreMoveAutomatically = false) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_STATUS, [id])
    return ConnectorWebService.put(url, { status, boardId, ignoreMoveAutomatically })
  }

  function reorderSubtask (taskId, subtaskId, newPosition) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_SUBTASK_ID_ORDER, [taskId, subtaskId])

    return ConnectorWebService.put(url, { subtaskId, newPosition })
  }

  /* Filter options:
   * 'sent': Show only attachments the user has sent
   * 'received': Show only attachments that are not from the requestor
   * 'public': Show only attachments that are not private to the marketing team
   * 'private': Show only attachments privates to the marketing team
   * 'requestorOnly': Show only attachments that are from the requestor
   */
  function batchDownloadAttachments (taskId, filter) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ATTACHMENTS_DOWNLOAD_BATCH, [taskId])

    url = Utils.fnAddQueryToUrl(url, { filter })

    return Utils.downloadFile(url)
  }

  function getCalendarTasks (date, boardId, filters, search) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_CALENDAR_BOARD_ID, [boardId])

    if (filters) {
      Object.keys(filters).forEach(key => {
        if (Array.isArray(filters[key]) && !filters[key].length) {
          delete filters[key]
        }
      })

      url = Utils.fnAddQueryToUrl(url, filters)
    }

    url = Utils.fnAddQueryToUrl(url, { date })
    url = Utils.fnAddQueryToUrl(url, { term: search })

    return ConnectorWebService.get(url)
  }

  function getRequestsByStatus (status, resultsLimit, sortParam) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_REQUESTS_STATUS, [status])

    if (resultsLimit) {
      url = Utils.fnAddQueryToUrl(url, { $top: resultsLimit.top || 10, $skip: resultsLimit.skip || 0 })
    }

    if (sortParam) {
      url = Utils.fnAddQueryToUrl(url, { $sort: sortParam.sort || 'id', $order: sortParam.order || 'DESC' })
    }

    return ConnectorWebService.get(url)
  }

  function getRequestsCountByStatus () {
    const url = CONSTANTS.URL_TASKS_REQUESTS_COUNT_STATUS

    return ConnectorWebService.get(url)
  }

  function addRelatedTask (id, relatedTaskId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_RELATEDTASK, [id])

    return ConnectorWebService.post(url, { relatedTaskId })
  }

  function deleteRelatedTask (id, relatedTaskId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_RELATEDTASK_ID, [id, relatedTaskId])

    return ConnectorWebService.fnDelete(url)
  }

  function getRecentTasks (taskId, options) {
    const { top, skip, sort, order, search } = options
    let url = CONSTANTS.URL_TASKS_RECENT

    url = Utils.fnAddQueryToUrl(url, { taskId })

    if (top || skip) {
      url = Utils.fnAddQueryToUrl(url, { $top: top, $skip: skip })
    }

    if (sort) {
      url = Utils.fnAddQueryToUrl(url, { $sort: sort })
    }

    if (order) {
      url = Utils.fnAddQueryToUrl(url, { $order: order })
    }

    if (search) {
      url = Utils.fnAddQueryToUrl(url, { search })
    }

    return ConnectorWebService.get(url)
  }

  function getRelatedTasks (id, options) {
    const { top, skip } = options
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_RELATEDTASK, [id])

    if (top || skip) {
      url = Utils.fnAddQueryToUrl(url, { $top: top, $skip: skip })
    }

    return ConnectorWebService.get(url)
  }

  function updateTaskPosition (task, from, to, position) {
    return BoardColumnsService.moveColumnTask(task.id, from, to, position).then(() => {
      SegmentService.track('moved-task', { task_id: task.id, type: task.originType })
    })
  }

  function changeTaskStatus (task, originColumn, destinationColumn, position, ignoreMoveAutomatically) {
    const newStatus = destinationColumn.defaultStatus || task.status

    return updateTaskPosition(task, originColumn.id, destinationColumn.id, position).then(() => {
      return updateTaskStatus(task.id, { status: newStatus, ignoreMoveAutomatically }).then(response => {
        updateTaskOcculted(task.id)
        return response
      })
    })
  }

  function changeSubtaskStatus (subtask, originColumn, destinationColumn, position, ignoreMoveAutomatically) {
    const newStatus = destinationColumn.defaultStatus || subtask.status

    return updateTaskPosition(subtask, originColumn.id, destinationColumn.id, position).then(() => {
      return updateSubtaskStatus(subtask.id, newStatus, destinationColumn.boardId, ignoreMoveAutomatically).then(response => {
        updateTaskOcculted(subtask.id)
        return response
      })
    })
  }

  function approveTask (id, params) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_APPROVE, [id])
    return ConnectorWebService.post(url, params)
  }

  function attachAssetToTask (taskId, assetId, isPrivate, assetName) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_ATTACHMENTS, [taskId])
    return ConnectorWebService.post(url, { assetId, isPrivate, assetName })
  }

  function removeAttachment (taskId, assetId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_ATTACHMENTS_ASSET_ID, [taskId, assetId])
    return ConnectorWebService.fnDelete(url)
  }

  function getMentionableUsersByTask ({ id, search }) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_MENTION, [id])
    if (search) url = Utils.fnAddQueryToUrl(url, { search })

    return ConnectorWebService.get(url)
  }

  function removeAttachmentsBatch (taskId, assetsIds) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_ATTACHMENTS_BATCH, [taskId])

    url = Utils.addQueryStringFromArray(url, 'assetsIds', assetsIds)

    return ConnectorWebService.fnDelete(url)
  }

  function bindTaskToCampaign (params = {}) {
    const { assetId, selectedCampaign } = params

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_BIND_CAMPAIGN, [assetId])
    return ConnectorWebService.put(url, { campaignId: selectedCampaign })
  }

  function unbindTaskFromCampaign (assetId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_UNBIND_CAMPAIGN, [assetId])
    return ConnectorWebService.put(url)
  }

  function duplicateTask (taskId, boardId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_DUPLICATE, [taskId])
    return ConnectorWebService.post(url, { boardId })
  }

  function getTaskDocuments (taskId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_DOCUMENTS, [taskId])
    return ConnectorWebService.get(url)
  }

  function createTaskDocument (params) {
    const { taskId, template } = params
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_DOCUMENTS, [taskId])
    return ConnectorWebService.post(url, { template })
  }

  function deleteTaskDocument (taskId, documentId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_DOCUMENTS_ID, [taskId, documentId])
    return ConnectorWebService.fnDelete(url)
  }

  function attachDocumentsToTask (taskId, assetsIds) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_DOCUMENTS_ATTACH, [taskId])
    return ConnectorWebService.post(url, { assetsIds })
  }

  function moveToNextColumn (taskId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TASKS_ID_MOVE_TO_NEXT_COLUMN, [taskId])
    return ConnectorWebService.put(url)
  }
}

export { tasksService }
